module.exports = __webpack_public_path__ + "afb57c4ecf21cdb65fcbdb82a4e4bdb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/ComeBack/assets/sec-4/shein.jpg
// module id = ./app/containers/StaticPage/ComeBack/assets/sec-4/shein.jpg
// module chunks = 40